import { gsap } from 'gsap';
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import { lg, xl } from '../common';

export function initTeamCarousel(parent) {
  if (!parent) return;

  const paginationEl = parent.querySelector('.swiper-pagination');

  new Swiper(parent, {
    modules: [Pagination],
    slidesPerView: 'auto',
    spaceBetween: 12,
    pagination: {
      el: paginationEl,
      clickable: true,
    },
    breakpoints: {
      // [md]: {
      //   slidesPerView: 4,
      //   spaceBetween: 12,
      // },
      [xl]: {
        slidesPerView: 5,
        spaceBetween: 12,
      },
    },
  });

  const cards = parent.querySelectorAll('.team-carousel__card');
  cards.forEach((card, index) => {
    gsap.set(card, {
      opacity: 0,
      scale: 0.8,
      yPercent: -15,
      transformOrigin: 'center center',
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: card,
        start: 'top 75%',
        toggleActions: 'play none none none',
      },
    });
    tl.to(card, {
      opacity: 1,
      scale: 1.02,
      yPercent: 0,
      duration: 0.5,
      ease: 'power1.out',
      delay: index * 0.1,
    }).to(card, {
      scale: 1,
      duration: 0.3,
      ease: 'power1.inOut',
    });
  });
}

export function initAllTeamCarousels(selector = '.js-team-carousel') {
  const blocks = document.querySelectorAll(selector);
  blocks.forEach((block) => initTeamCarousel(block));
}
